import { autoinject } from 'aurelia-dependency-injection';
import { InstrumentTypesCache } from '../services/instrument-types-cache';
import { InstrumentTypeViewModel } from '../clients/transaction-clients';

@autoinject
export class InstrumentTypeValueConverter {
  constructor(private instrumentTypesCache: InstrumentTypesCache) { }

  instrumentTypes: InstrumentTypeViewModel[];

  toView(id?: number) {
    return id !== undefined ? this.instrumentTypes?.find(x => x.id === id)?.name ?? '???' : undefined;
  }

  async init() {
    this.instrumentTypes = await this.instrumentTypesCache.instrumentTypes;
  }
}
